import moment from 'moment-timezone';

import bookingCancellationOptions from '../shared_configs/bookingCancellationOptions';
import bookingStatuses from '../shared_configs/bookingStatuses';

export const cancellationOptionText = (cancellationOption, time) => {
  if (cancellationOption === bookingCancellationOptions.never.option) {
    return 'No cancellations or changes are allowed once the appointment is booked.';
  } else if (cancellationOption === bookingCancellationOptions.specified.option) {
    return `No cancellations or changes allowed within ${time} of the appointment.`;
  }

  return '';
};

export const clientMessageByBookingStatus = (status) => {
  if (status === bookingStatuses.confirmed.status) {
    return 'We\'ve sent a confirmation email to you.';
  }

  return 'Your appointment is pending. We will send confirmation email to you when it\'s approved.';
};

export const getClientDataFromBrowser = () => {
  try {
    const stringData = localStorage.getItem('bookingClientData');
    return stringData ? JSON.parse(stringData) : null;
  } catch (error) {
    console.log(error);
    return null;
  }
};
export const keepClientDataInBrowser = (client) => {
  const serializedData = JSON.stringify(client);
  try {
    return localStorage.setItem('bookingClientData', serializedData);
  } catch (error) {
    console.log(error);
    return null;
  }
};
export const clearClientDataFromBrowser = () => {
  try {
    return localStorage.removeItem('bookingClientData');
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const formatDate = (dateTz) => dateTz.format('ddd, ll');
export const formatTime = (timeTz) => timeTz.format('h:mm a');

export const getInvoiceFilenameForCustomer = (options) => {
  const { datetime, timezone, firstName, lastName } = options;
  const formattedDatatime = moment.tz(datetime, timezone).format('MM-DD-YY');

  return `${formattedDatatime}-${lastName}-${firstName}`;
};
